import React from "react";
import "./VisualGallery.css";
import img1 from "../../assets/SocialAndVertical/Copy of Culinary 1.jpg";
import img2 from "../../assets/SocialAndVertical/Copy of Culinary 2-2.jpg";
import img3 from "../../assets/SocialAndVertical/Copy of Culinary 3-2.jpg"

import img4 from "../../assets/SocialAndVertical/Copy of Grey Heron Vertical 1.jpg";
import img5 from "../../assets/SocialAndVertical/Copy of Grey Heron Vertical 2.jpg";
import img6 from "../../assets/SocialAndVertical/Copy of Grey Heron Vertical 3.jpg";
import img7 from "../../assets/SocialAndVertical/Copy of Grey Heron Vertical 4.jpg";
import img8 from "../../assets/SocialAndVertical/Copy of Grey Heron Vertical 5.jpg";
import img9 from "../../assets/SocialAndVertical/Copy of Grey Heron Vertical 6-2.jpg";

import img10 from "../../assets/SocialAndVertical/Copy of Mehendi Vertical.jpg";
import img11 from "../../assets/SocialAndVertical/Copy of Mehendi Vertical.jpg";
import img12 from "../../assets/SocialAndVertical/Copy of Proposal Vertical.jpg";
import img13 from "../../assets/SocialAndVertical/Copy of Varmala.jpg";
import img14 from "../../assets/SocialAndVertical/Copy of Vidai.jpg";
import img15 from "../../assets/SocialAndVertical/Copy of Sunder Emporium.jpg";


import img16 from "../../assets/SocialAndVertical/Copy of Bharat Vista.jpg";
import img17 from "../../assets/SocialAndVertical/Copy of Alaknanda.jpg";
import img18 from "../../assets/SocialAndVertical/Copy of Hiranandani.jpg";
import img19 from "../../assets/SocialAndVertical/Copy of Paradigm.jpeg";
import img20 from "../../assets/SocialAndVertical/Copy of Realcon.jpg";
import img27 from "../../assets/SocialAndVertical/Copy of Vyom.jpg"


import img21 from "../../assets/SocialAndVertical/Copy of Nikron Vertical 1.jpg";
import img22 from "../../assets/SocialAndVertical/Copy of Nikron Vertical 2.jpg";
import img23 from "../../assets/SocialAndVertical/Copy of Nikron Vertical 3.jpeg";
import img24 from "../../assets/SocialAndVertical/Copy of Nikron Vertical 4.jpg";
import img25 from "../../assets/SocialAndVertical/Copy of Nikron Vertical 5.png";
import img26 from "../../assets/SocialAndVertical/Copy of Nikron Vertical 6.jpg";



const pageData = {
  "real-estate": {
    title: "REAL ESTATE",
    subtitle: "TEXT",
    active: "REAL ESTATE",
    images: [
      {
        image: img16,
        title: "Bharat Vista",
      },
      {
        image: img17,
        title: "Alaknanda",
      },
      {
        image: img27,
        title: "Gurukrupa Vyom",
      },
      {
        image: img18,
        title: "Hirangandani",
      },
      {
        image: img19,
        title: "Paradigm",
      },
      {
        image: img20,
        title: "Realcon",
      },
    ],
  },

  nikron: {
    title: "NIKRON",
    subtitle: "TEXT",
    active: "NIKRON",
    images: [
      {
        image: img21,
      },
      {
        image: img22,
      },
      {
        image: img23,
      },
      {
        image: img24,
      },
      {
        image: img25,
      },
      {
        image: img26,
      },
    ],
  },

  jewellery: {
    title: "JEWELLERY",
    subtitle: "TEXT",
    active: "JEWELLERY",
    images: [
      {
        image: img10,
      },
      {
        image: img11,
      },
      {
        image: img12,
      },
      {
        image: img13,
      },
      {
        image: img14,
      },
      {
        image: img15,
      },
    ],
  },

  fashion: {
    title: "FASHION",
    subtitle: "TEXT",
    active: "FASHION",
    images: [
      {
        image: img4,
      },
      {
        image: img5,
      },
      {
        image: img6,
      },
      {
        image: img7,
      },
      {
        image: img8,
      },
      {
        image: img9,
      },
    ],
  },

  "social-and-vertical-films": {
    title: "SOCIAL AND VERTICAL FILMS",
    subtitle: "CULINARY AND BEYOND",
    active: "SOCIAL AND VERTICAL FILMS",
    images: [
      {
        image: img1,
      },
      {
        image: img2,
      },
      {
        image: img3,
      },
    ],
  },
};


const categories = [
  "CAMPAIGNS",
  "COMMERCIALS",
  "BRAND FILMS",
  "CORPORATE FILMS",
  "DOCUMENTARIES",
  "EVENTS",
  "PODCASTS & INTERVIEWS",
  "SOCIAL AND VERTICAL FILMS",
];


function makeSlug(category) {
  return category
    .toLowerCase()
    .replace(/&/g, "and")
    .replace(/\s+/g, "-");
}


function VisualGallery({ type }) {

  const data = pageData[type];

  if (!data) {
    return (
      <div className="visual-gallery-error">
        Page not found
      </div>
    );
  }


 const goToCategory = (category) => {
    const routes = {
        "CAMPAIGNS": "/campaigns",
        "COMMERCIALS": "/commercials",
        "BRAND FILMS": "/brand-films",
        "CORPORATE FILMS": "/corporate-films",
        "DOCUMENTARIES": "/documentaries",
        "PODCASTS & INTERVIEWS": "/podcasts",
    };

    const route = routes[category];

    if (route) {
        window.location.href = route;
    }
};


  return (
    <main className="visual-gallery-page">

      <div className="visual-gallery-shell">

        {/* =================================
            HEADER
        ================================= */}

        <header className="visual-gallery-header">

          <h1>
            {data.title}
          </h1>

          <div className="visual-gallery-rule">

            <span>
              {data.subtitle}
            </span>

          </div>

        </header>


        {/* =================================
            GALLERY
        ================================= */}

        <section className="visual-gallery-grid">

          {data.images.map((item, index) => (

            <article
              className="visual-gallery-card"
              key={index}
            >

              <img
                src={item.image}
                alt={item.title || `${data.title} ${index + 1}`}
              />

              <div className="visual-gallery-overlay"></div>


              {item.title && (
                <div className="visual-gallery-card-title">
                  {item.title}
                </div>
              )}

            </article>

          ))}

        </section>
      {/* =================================
    SECONDARY PORTFOLIO SECTIONS
================================= */}

{type === "social-and-vertical-films" && (
  <div className="visual-gallery-secondary-sections">

    {/* ===============================
        FASHION
    =============================== */}

    <section className="visual-gallery-secondary">

      <header className="visual-gallery-secondary-header">

        <div className="visual-gallery-secondary-title-wrap">

          <span className="visual-gallery-secondary-label">
            THE FASHION ARCHIVE
          </span>

          <h2>
            FASHION
          </h2>

        </div>

        <div className="visual-gallery-secondary-line"></div>

      </header>

      <div className="visual-gallery-secondary-grid">

        {pageData.fashion.images.map((item, index) => (

          <article
            className="visual-gallery-secondary-card"
            key={`fashion-${index}`}
          >

            <img
              src={item.image}
              alt={`Fashion ${index + 1}`}
            />

            <div className="visual-gallery-secondary-overlay"></div>

            <span className="visual-gallery-frame-number">
              {String(index + 1).padStart(2, "0")}
            </span>

          </article>

        ))}

      </div>

    </section>


    {/* ===============================
        JEWELLERY
    =============================== */}

    <section className="visual-gallery-secondary">

      <header className="visual-gallery-secondary-header">

        <div className="visual-gallery-secondary-title-wrap">

          <span className="visual-gallery-secondary-label">
            CRAFTED TO SHINE
          </span>

          <h2>
            JEWELLERY
          </h2>

        </div>

        <div className="visual-gallery-secondary-line"></div>

      </header>

      <div className="visual-gallery-secondary-grid">

        {pageData.jewellery.images.map((item, index) => (

          <article
            className="visual-gallery-secondary-card"
            key={`jewellery-${index}`}
          >

            <img
              src={item.image}
              alt={`Jewellery ${index + 1}`}
            />

            <div className="visual-gallery-secondary-overlay"></div>

            <span className="visual-gallery-frame-number">
              {String(index + 1).padStart(2, "0")}
            </span>

          </article>

        ))}

      </div>

    </section>


    {/* ===============================
        FOOTWEAR
    =============================== */}

    <section className="visual-gallery-secondary">

      <header className="visual-gallery-secondary-header">

        <div className="visual-gallery-secondary-title-wrap">

          <span className="visual-gallery-secondary-label">
            THE SOLE SOCIETY
          </span>

          <h2>
            FOOTWEAR
          </h2>

        </div>

        <div className="visual-gallery-secondary-line"></div>

      </header>

      <div className="visual-gallery-secondary-grid">

        {pageData.nikron.images.map((item, index) => (

          <article
            className="visual-gallery-secondary-card"
            key={`footwear-${index}`}
          >

            <img
              src={item.image}
              alt={`Footwear ${index + 1}`}
            />

            <div className="visual-gallery-secondary-overlay"></div>

            <span className="visual-gallery-frame-number">
              {String(index + 1).padStart(2, "0")}
            </span>

          </article>

        ))}

      </div>

    </section>


    {/* ===============================
        REAL ESTATE
    =============================== */}

    <section className="visual-gallery-secondary">

      <header className="visual-gallery-secondary-header">

        <div className="visual-gallery-secondary-title-wrap">

          <span className="visual-gallery-secondary-label">
            STORIES BEYOND SQUARE FEET
          </span>

          <h2>
            REAL ESTATE
          </h2>

        </div>

        <div className="visual-gallery-secondary-line"></div>

      </header>

      <div className="visual-gallery-secondary-grid">

        {pageData["real-estate"].images.map((item, index) => (

          <article
            className="visual-gallery-secondary-card"
            key={`real-estate-${index}`}
          >

            <img
              src={item.image}
              alt={item.title || `Real Estate ${index + 1}`}
            />

            <div className="visual-gallery-secondary-overlay"></div>

            {item.title && (
              <div className="visual-gallery-secondary-card-title">
                {item.title}
              </div>
            )}

            <span className="visual-gallery-frame-number">
              {String(index + 1).padStart(2, "0")}
            </span>

          </article>

        ))}

      </div>

    </section>

  </div>
)}
        {/* =================================
            CATEGORY NAVIGATION
        ================================= */}

        <nav className="visual-gallery-nav">

          <button
            className="visual-gallery-arrow"
            onClick={() => {
              const currentIndex =
                categories.indexOf(data.active);

              const previousIndex =
                currentIndex <= 0
                  ? categories.length - 1
                  : currentIndex - 1;

              goToCategory(
                categories[previousIndex]
              );
            }}
          >
            ←
          </button>


          <div className="visual-gallery-category-list">

            {categories.map((category) => (

              <button
                key={category}
                className={`visual-gallery-category ${category === data.active
                  ? "active"
                  : ""
                  }`}
                onClick={() =>
                  goToCategory(category)
                }
              >
                {category}
              </button>

            ))}

          </div>


          <button
            className="visual-gallery-arrow"
            onClick={() => {

              const currentIndex =
                categories.indexOf(data.active);

              const nextIndex =
                currentIndex === categories.length - 1
                  ? 0
                  : currentIndex + 1;

              goToCategory(
                categories[nextIndex]
              );

            }}
          >
            →
          </button>

        </nav>

      </div>

    </main>
  );
}


export default VisualGallery;